import Icons from "./icons";
import Images from "./images";
import SvgImages from "./svg";

export default {
  ...Icons,
  ...Images,
  ...SvgImages
};
